import { throwError as observableThrowError } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Config } from '../models';


@Injectable({
	providedIn: 'root'
})
export class ConfigService {
	protected options: any;
	private config!: Config;

	constructor(protected http: HttpClient) {
		this.options = new HttpHeaders({'Content-Type': 'application/json'});
	}

	getConfig(): Config {
		return this.config;
	}

	loadConfig(url: string = 'config/config.json'): Promise<any> {
		return new Promise((resolve: any, reject: any): any => {
			const request = this.http.get(url, this.options).pipe(
				map((res: any) => {
					return res;
				}),
				catchError((error: any) => {
					reject(false);
					return observableThrowError(error || 'Server error');
				}));

			request.subscribe((data: Config) => {
				this.config = data;
				resolve(true);
			}, (error: any) => {
				console.error('Config Read Error', error);
			});
		});
	}
}
